import {
    Call,
    DOUBLE,
    PASS,
    REDOUBLE,
    bidLevel,
    bidStrain
} from "@ravalmatic/bridge-engine/core";

export class BiddingHistoryCell extends Phaser.GameObjects.Container {

    private readonly background: Phaser.GameObjects.Image;
    private readonly levelLabel: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene, x: number, y: number) {

        super(scene, x, y);

        this.background = new Phaser.GameObjects.Image(
            scene,
            0,
            0,
            "texture_atlas_1",
            "bidding_cell_empty"
        );
        this.levelLabel = new Phaser.GameObjects.Text(scene, -16, 0, "", {
            color: "#0e2d57",
            fontFamily: "Baloo2-SemiBold",
            fontSize: "26px"
        });
        this.levelLabel.setOrigin(.5);
        this.add([this.background, this.levelLabel]);
    }

    public setCall(call: Call | null): void {

        this.levelLabel.setText("");

        if (call === null) {
            this.background.setFrame("bidding_cell_empty");
        } else if (call === PASS) {
            this.background.setFrame("bidding_selection_pass");
        } else if (call === DOUBLE) {
            this.background.setFrame("bidding_selection_double");
        } else if (call === REDOUBLE) {
            this.background.setFrame("bidding_selection_redouble");
        } else {
            const suffix = ["clubs", "diamonds", "hearts", "spades", "nt"][bidStrain(call)];
            this.background.setFrame(`bidding_selection_${suffix}`);
            this.levelLabel.setText(`${bidLevel(call)}`);
        }
    }
}